<div class="notifications" *ngIf="notificationsModel">
  <label class="notifications-container" *ngFor="let notification of notificationsModel.notificationTypes">
    {{notification.name}}
    <input class="notifications-container_input" (change)="addOrRemoveUserNotification(notification)"
           [(ngModel)]="notification.isChecked" type="checkbox" >
    <span class="notifications-container_checkmark"></span>
  </label>
</div>
